import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { ADAPTER_SVC_PARTNER_PORTAL_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { routeReplacer } from '~/Helpers/String.helper';
import { IIntegrationChannelData } from '~/Models/DTO/IntegrationChannels.model';

interface IChannels {
  providerId: string;
}

export const useRequestChannels = ({ providerId }: IChannels) =>
  useQuery<IIntegrationChannelData, IErrorResponse>(
    [REQUEST_ACTIONS.GET_ALL_INTEGRATION_CHANNELS, providerId],
    async () =>
      await requestReactQuery<IIntegrationChannelData>({
        url: routeReplacer(ADAPTER_SVC_PARTNER_PORTAL_URLS.GET_INTEGRATION_CHANNELS, {
          providerId,
        }),
        config: { method: 'GET' },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      refetchInterval: TIME_VALUES.HOUR,
      enabled: !!providerId,
    },
  );
